<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: aliceblue;
}
.input-box select,
.input-box input,
.input-box textarea {
  background: transparent;
  border: 0;
  font-size: 1em;
  color: var(--inputColor);
  width: 100%;
  padding: 0 0.5em;
  box-sizing: border-box;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// App.vue?3bd7b1c8